export const IMAGE_BASE_URL = "https://mtt56sports.s3-us-west-2.amazonaws.com";
